<!--发布通知  -->
<template>
  <div>
    <!-- 移动端发布任务页面 -->
    <img
      src="@/assets/infoPublic/images/task_detailBg.png"
      alt="bg_mobile"
      class="ContentDetail_image"
    />
    <div class="task_header">
      <div class="task_header_title">
        <span
          @click="ChangePage(1)"
          class="active_span"
          v-bind:style="{'font-weight':(type===1?'blod':'normal')}"
        >
          <i v-bind:style="{'background-color':(type===1?'#DFAB49':'transparent')}"></i>内容详情
        </span>
        <span
          @click="ChangePage(2)"
          class="active_span"
          v-bind:style="{'font-weight':(type===2?'blod':'normal')}"
        >
          <i v-bind:style="{'background-color':(type===2?'#DFAB49':'transparent')}"></i>执行详情
        </span>
      </div>
      <!-- 内容详情 -->
      <div v-show="type===1" class="task_left">
        <div ref="inDemo" v-if="detailObj.length !== 0" style="margin-bottom: 1.50px">
          <div
            v-for="item in detailObj"
            v-bind:key="item"
            slot="list"
            style=" margin-bottom: 30px;height: 86px;"
          >
            <img
              v-if="item.ResourceTypeName !== '照片' && item.ResourceTypeName!=='视频'"
              src="@/assets/infoPublic/images/info_bg1.png"
              alt
            />
            <img v-else src="@/assets/infoPublic/images/info_bg3.png" alt />
            <div class="task_left_contnet">
              <!-- 左 -->
              <div
                class="task_left_time"
                v-if="item.ResourceTypeName!=='照片'&&item.ResourceTypeName!=='视频'"
              >
                <div style="margin-bottom: 15px">
                  <p v-cloak class="hour">{{item.startTimeArr[1]}}</p>
                  <p v-cloak class="year_month_day">{{item.startTimeArr[0]}}</p>
                </div>
                <div>
                  <p v-cloak class="hour">{{item.endTimeArr[1]}}</p>
                  <p v-cloak class="year_month_day">{{item.endTimeArr[0]}}</p>
                </div>
              </div>
              <div class="task_left_info">
                <p style="margin-bottom: 4px" v-cloak>{{item.ResourceTypeName||"--"}}</p>
                <p v-cloak class="nowrap" style="width:100%;">{{item.ResourceTitle||"--"}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 执行详情 -->
      <div v-show="type===2" style="margin-bottom: 1.50px;">
        <div
          v-bind:callback="GetPublicTaskInfoByPage"
          ref="infinitescrollDemo"
          v-if="publishToClassBrandList.length !== 0"
          style="margin-bottom: 10px"
        >
          <div
            class="background"
            v-for="(item, index) of publishToClassBrandList"
            v-bind:key="index"
            slot="list"
          >
            <div class="content_detail">
              <span class="classbrand_name" v-cloak>{{item.ClassTerminalName}}</span>
              <span class="send_btn" v-cloak>{{item.PublishStatusName}}</span>
              <span v-show="item.IsRevoke!==0" style="color: rgba(113, 87, 69, 1);">|</span>
              <span
                class="withdraw_btn"
                v-cloak
                v-show="item.IsRevoke!==0"
              >{{item.RevokeName=== "正常" ? '--' : item.RevokeName}}</span>
            </div>
          </div>
        </div>
        <div v-else class="xy-phone-no-data" style="margin-top: 50%">
          <img src="@/assets/common/moblie-no-data.png" />
          <p>暂无班牌信息</p>
        </div>
      </div>
    </div>
    <div class="footer">
      <p
        class="Revoke_btn"
        v-bind:class="status===2||status===3||status===5?'Revoke_btn':'Revoke_btn disabStyle'"
        @click="WithDraw"
      >撤销</p>
      <p
        @click="EditFun"
        v-bind:class="status===3||status===4||status===5?'Edit_btn disabStyle':'Edit_btn'"
      >编辑</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContentDetail",
  data() {
    return {
      type: 1,
      status: "",
      detailObj: [], //内容详情
      publishTaskID: "",
      PageCurrent: 1,
      PageSize: 10,
      publishToClassBrandList: [], //发布到的班牌list
      totalAll: 0, //这条通知总共发布到多个班牌,
      isClickWithDrawBtn: false, //是否点击撤销按钮,
      classTerminalIDs: [], //当前任务已发布到哪些班牌
      PublishTaskInfo: ""
    };
  },
  computed: {},
  created() {
    this.PublishTaskInfo = this.$store.state.infoPublic.val;
    this.status = this.PublishTaskInfo.PublishTaskStatus;
    this.detailClick();
    this.GetPublicTaskInfoByPage();
  },
  methods: {
    // 初始tab
    ChangePage(val) {
      this.type = val;
    },
    // 查看列表中---内容详情,获取此条任务已发布到哪些班牌
    async detailClick() {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/PublicTask/GetPublicTaskByID`,
        {
          id: this.PublishTaskInfo.PublishTaskID
        }
      );
      this.xy.unloading();
      if (res.success) {
        if (res.data) {
          this.detailObj = res.data.PublischTaskDetails;
          this.PublishTaskInfoData = res.data;
          this.detailObj.forEach(function(item) {
            item.startTimeArr = item.StartDate.split(" ");
            item.startTimeArr[1] = item.startTimeArr[1].slice(
              0,
              item.startTimeArr[1].length - 3
            ); //截取秒，只保留分钟
            item.endTimeArr = item.EndDate.split(" ");
            item.endTimeArr[1] = item.endTimeArr[1].slice(
              0,
              item.endTimeArr[1].length - 3
            );
          });
        }
        if (res.data.ClassTerminalID.length > 0) {
          for (var i = 0; i < res.data.ClassTerminalID.length; i++) {
            this.classTerminalIDs.push({
              ClassTerminalID: res.data.ClassTerminalID[i],
              ClassTerminalName: res.data.ClassTerminalName[i]
            });
          }
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },

    // 获取执行结果详情列表
    async GetPublicTaskInfoByPage() {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/PublicTask/GetPublicTaskInfoByPage`,
        {
          PageIndex: this.PageCurrent,
          PageSize: this.PageSize,
          PublishTaskID: this.PublishTaskInfo.PublishTaskID,
          SearchText: "",
          PublishStatus: "-1"
        }
      );
      this.xy.unloading();
      if (res.success) {
        var result = [];
        result = res.data.data;
        this.totalAll = res.data.totalRecords;
        var totalPages = Math.ceil(res.data.totalRecords / this.PageSize);
        if (result !== null && result.length > 0) {
          this.publishToClassBrandList = [
            ...this.publishToClassBrandList,
            ...result
          ];
          /* 所有数据加载完毕 */
          if (this.pageCurrent >= totalPages) {
            this.$refs.infinitescrollDemo.$emit(
              "ydui.infinitescroll.loadedDone"
            );
            return;
          }
          /* 单次请求数据完毕 */
          this.pageCurrent++;
          this.$refs.infinitescrollDemo.$emit("ydui.infinitescroll.finishLoad");
        } else {
          this.publishToClassBrandList = [];
          this.$refs.infinitescrollDemo.$emit("ydui.infinitescroll.loadedDone");
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },

    //撤销
    WithDraw() {
      if (
        this.PublishTaskInfo.PublishTaskStatus === 2 ||
        this.PublishTaskInfo.PublishTaskStatus === 3 ||
        this.PublishTaskInfo.PublishTaskStatus === 5
      ) {
        //点击撤销按钮 列表✌下面的状态显示 撤销结果  未点击撤销按钮  默认下方的状态显示为发布状态
        var tipContent = "";
        var row = this.PublishTaskInfo;
        if (row.PublishTaskType === 8 || row.PublishTaskType === 9) {
          tipContent = "撤销后此控件将无显示内容,确定要撤销吗?";
        } else {
          tipContent = "确定要撤销吗？";
        }
        //--------------------弹出框---------------------------------------
        // 当前是最后一题，提交后会返回方案列表，您确定要提交问卷吗？
        this.xy.confirm("撤销", tipContent, () => {
          //this.loading("撤销中");
          this.lastPost();
        });
      }
    },

    // 撤销
    async lastPost() {
      let res = await this.xyapi.post(
        `${this.$store.state.apiPath}/api/PublicTask/RevokePublicTaskStatus?id=${this.PublishTaskInfo.PublishTaskID}`
      );
      if (res.success) {
        this.$toast.fail("撤销成功！");
        this.publishToClassBrandList = [];
        this.PageCurrent = 1;
        this.GetPublicTaskInfoByPage();
        this.$nextTick(() => {
          this.isClickWithDrawBtn = true;
        });
        this.$router.push('/home/PublishTake');
        //获取任务记录所有数据，判断 编辑或撤销按钮是否可以点击
        this.GetTaskList();
      } else {
        this.$toast.fail(res.msg);
      }
    },

    //获取列表数据
    async GetTaskList() {
      var that = this;
      let obj = {
        PageIndex: 1,
        PageSize: 10,
        PublishTaskType: 0,
        PublishTaskStatus: 0,
        SearchText: this.PublishTaskInfo.PublishTaskName,
        BeginDate: "",
        EndDate: ""
      };
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/PublicTask/GetPublicTaskByPage`,
        obj
      );
      if (res.success) {
        var result = res.data.data;
        result.forEach(item => {
          if (item.PublishTaskID === that.PublishTaskInfo.PublishTaskID) {
            that.PublishTaskInfo = item;
            that.status = item.PublishTaskStatus;
          }
        });
      } else {
        this.$toast.fail(res.msg);
      }
    },

    // 编辑 跳转到选择班牌的页面
    EditFun: function() {
      // 只有未审批才能编辑

      console.log(this.PublishTaskInfo);

      if (
        this.PublishTaskInfo.PublishTaskStatus !== 3 &&
        this.PublishTaskInfo.PublishTaskStatus !== 4 &&
        this.PublishTaskInfo.PublishTaskStatus !== 5
      ) {
        var classTerminal = this.classTerminalIDs;
        this.type = this.PublishTaskInfo.PublishTaskType;
        this.PublishTaskInfo = this.PublishTaskInfoData;
        console.log(this.PublishTaskInfo);
        console.log(this.filesUrls);
        this.$store.commit(
          "infoPublic/setPublishTaskInfo",
          this.PublishTaskInfo,
          this.filesUrls
        );
        this.$store.commit("infoPublic/setPicfilesUrls", this.filesUrls);
        this.$store.commit("infoPublic/settypePic", this.type);
        this.$store.commit("infoPublic/setclassTerminal", classTerminal);
        this.$router.push("/home/SelectClassCard");
      }
    }
  }
};
</script>
<style lang="less" scoped>
span {
  display: inline-block;
}

.background {
  background: #fff;
}

.ContentDetail_bg {
  color: white;
  width: 100%;
}

.ContentDetail_image {
  margin-top: -150px;
  width: 100%;
  height: 400px;
}

.task_header {
  position: absolute;
  width: 100%;
  padding: 0 0 20px;
  background: #fff;
  border-radius: 60px 60px 0 0;
  left: 0;
  top: 200px;
  bottom: 10px;
}

.task_header_title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f5;
  height: 108px;
}

.active_span > i {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /* background-color: transparent; */
  margin-right: 24px;
  vertical-align: middle;
}

.task_header_title > span {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: rgba(17, 17, 17, 1);
  font-weight: bold;
}

/* 内容详情样式 */
.task_left {
  width: 90%;
  margin: 30px auto 0 auto;
  padding: 20px 0;
  border-radius: 60px 60px 0 0;
  margin-bottom: 1.5px;
}
/*
  .task_left>div {
      margin-bottom: 30px;
      height: 2.060px;
  } */
.task_left .yd-list-loading {
  display: none;
}
.task_left img {
  width: 100%;
  height: 100%;
}

.task_left .task_left_contnet {
  width: 100%;
  display: flex;
  padding: 20px;
  height: 100%;
  margin-top: -166px;
}

.task_left_time {
  width: 30%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.task_left_info {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.hour {
  font-size: 28px;
  font-weight: bold;
  color: rgba(17, 17, 17, 1);
}

.year_month_day {
  font-size: 20px;
  font-weight: 400;
  color: rgba(112, 113, 135, 1);
}

.task_left_info > p:first-child {
  margin-bottom: 40px;
  font-size: 30px;
  font-weight: bold;
  color: rgba(17, 17, 17, 1);
}

.task_left_info > p:last-child {
  font-size: 28px;
  font-weight: normal;
  color: rgba(24, 24, 42, 1);
}

.task_title,
.task_content,
.content_title {
  font-family: Hiragino Sans GB;
}

.task_date,
.task_time {
  font-family: Microsoft YaHei;
}

/* 执行详情 */
.content_detail {
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px dashed rgba(198, 197, 201, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.classbrand_name {
  width: 60%;
  font-size: 28px;
  color: rgba(51, 51, 51, 1);
}

.send_btn {
  margin-right: 15px;
}

.send_btn,
.withdraw_btn {
  padding: 10px 2px;
  /* background: rgba(249, 249, 249, 1); */
  border-radius: 40px;
  font-size: 24px;
  color: rgba(113, 87, 69, 1);
}

/* 页脚按钮 */

.footer {
  width: 100%;
  height: 120px;
  padding: 20px 80px;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border-top: 1px solid rgba(186, 186, 186, 32);
  background: #fff;
  box-shadow: 00px 20px 80px 00px rgba(186, 186, 186, 32);
}

.Revoke_btn,
.Edit_btn {
  width: 40%;
  padding: 15px 0;
  font-size: 30px;
  font-weight: normal;
  border-radius: 380px;
  text-align: center;
}

.Edit_btn {
  color: rgba(255, 255, 255, 1);
  background: rgba(65, 150, 255, 1);
}

.Revoke_btn {
  margin-right: 30px;
  background: rgba(255, 255, 255, 1);
  color: rgba(65, 150, 255, 1);
  border-radius: 380px;
  border: 1px solid rgba(65, 150, 255, 1);
}

.disabStyle {
  background-color: #ccc;
  color: #f0f0f0;
  border: 1px solid #ccc;
}
</style>
